import {PageRootSimpleSpa} from "../../common/layout/PageRootSimpleSpa";

export default function EmailVerified() {
    return (
        <PageRootSimpleSpa title={'Email verified'}>Your Email is verified!</PageRootSimpleSpa>
    )
}